// extracted by mini-css-extract-plugin
module.exports = {"p12":"globalClass_p12__3IrNW"};